import { PayoutStatus } from '../types/enums/PayoutStatus';
import { PayoutSummary } from '../types/PayoutSummary';
import { PayoutTransactionsPaginated } from '../types/PayoutTransactionsPaginated';
import { ApiService } from './apiService';

export class PayoutService {
  private apiService = new ApiService();

  async getPayoutCriteria(): Promise<Record<string, any>> {
    const response = await this.apiService.get('/api/payout/settings');
    const json = response.data as Record<string, any>;
    return json;
  }

  async requestPayout(amount: string, password: string): Promise<void> {
    const data: Record<string, string> = {
      amount: amount,
      password: password,
    };

    await this.apiService.post('/api/payout/request_payout', data, {
      authenticate: true,
    });
  }

  async getPayout(): Promise<PayoutSummary> {
    const response = await this.apiService.get('/api/payout/statement');
    const json = response.data as Record<string, any>;
    return PayoutSummary.fromJson(json);
  }

  async getPayoutTransactionPaginated({
    cursor,
    payoutStatus,
  }: {
    cursor?: string | null;
    payoutStatus?: PayoutStatus[];
  }): Promise<PayoutTransactionsPaginated> {
    const params: Record<string, any> = {};
    if (cursor) {
      params['cursor'] = cursor;
    }
    if (payoutStatus && payoutStatus.length > 0) {
      params['payout_status[]'] = payoutStatus.map((status) =>
        status.toString()
      );
    }

    const response = await this.apiService.get('/api/payout/transactions', {
      queryParams: params,
    });
    const json = response.data as Record<string, any>;
    return PayoutTransactionsPaginated.fromJson(json);
  }
}
